export default __webpack_public_path__ + "static/media/realme.2eecf906.png";